export const RETE_TUTOR_STATE = {
  0: 'In preparazione',
  1: 'Inviata',
  2: 'In lavorazione',
  3: 'Non perfezionata',
  4: 'Operativa',
};



// WEBPACK FOOTER //
// ./app/components/TutorList/List/constantReteTutor.js